<div class="header">
  <h3>{{'SEARCH.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearSearch()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="customercode"
          [options]="customercode"
          [(ngModel)]="selectedCustomercode"
          (onChange)="filterDeliverycodeList()"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}"
          [style]="{'z-index': 3}"
          filter="true"
        >
        </p-dropdown>
        <label for="customercode">{{'FILTER.CUSTOMER-CODE' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10 d-none">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBusiness"
          [options]="homeproGroup"
          [(ngModel)]="selectedHomeproGroup"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.BUSINESS-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="companyBusiness">{{'FILTER.BUSINESS-TYPE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-2">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="customercodeDeliverycode"
          [options]="deliverycodeList"
          [(ngModel)]="selectedDeliverycode"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DELIVERY-CODE' | translate}}"
          filter="true"
        >
        </p-dropdown>
        <label for="customercodeDeliverycode">{{'FILTER.DELIVERY-CODE' | translate}}</label>
      </div>

      <div class="d-none">
        <p-autoComplete [(ngModel)]="deliverycode" [disabled]="allDeliverycode" field="full_name" [multiple]="true"
                        [suggestions]="deliverycodeSuggest" [size]="30" (completeMethod)="searchDeliverycode($event)"
                        (onClear)="clearDeliverycode()" class="dv-autocomplete" placeholder="{{'FILTER.DELIVERY-CODE' | translate}}">
        </p-autoComplete>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}">
        </p-autoComplete>
      </div>
    </div>

    <div class="col-md-6">
      <div class="dropdown-label-group pr-5">

        <p-multiSelect
          class="dv-dropdown"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [panelStyle]="{minWidth: '473px'}"
          [defaultLabel]="defaultLabel"
          [maxSelectedLabels]="3"
        >
        </p-multiSelect>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>

  </div>

  <div class="row row-eq-height m-t-10">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="inputText" placeholder="{{'FILTER.DOCUMENT-NUMBER' | translate}}">
        <label for="searchText">{{'FILTER.DOCUMENT-NUMBER' | translate}}</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>

      <div class="row align-items-center" style="height: 50%">
        <div class="col d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDeliverycode" binary="true" (onChange)="selectAllDeliverycode()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allBranch" (change)="selectAllBranch()">-->
          <span>{{'COMMON.ALL-DELIVERY-CODE' | translate}}</span>
        </div>
      </div>
      <div class="row align-items-center" style="height: 50%;">
        <div class="col-md-auto d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDocType" binary="true" (onChange)="selectDocType()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allDocType" (change)="selectDocType()">-->
          <span>{{'COMMON.ALL-TYPES-DOCUMENTS' | translate}}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >

    <!--<button type="button" class="btn btn-dv btn-clean btn-wide" (click)="selectAll()">เลือกทั้งหมด</button>-->
    <button type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()"
            (click)="DownloadSelected(content2, 'xml')">
      {{'COMMON.DOWNLOAD' | translate}} XML
    </button>
    <button type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()"
            (click)="DownloadSelected(content2, 'pdf')">
      {{'COMMON.DOWNLOAD' | translate}} PDF
    </button>
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center ">
    <div class="">
    <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th scope="col">
            Send
          </th>
          <th scope="col">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)" [ngModel]="checkAll"></p-checkbox>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.customer_code}}</td>
          <td>{{data.delivery_code}}</td>
          <td>{{data.header_issue_dt | date:"dd/MM/yyyy" }}</td>
          <td>{{data.header_invoice_number}}</td>
          <td>{{data.delivery_no}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{data.rd_document_type_display}}</td>
          <!--<td>{{data.buyer_name}}</td>-->
          <td>{{data.total_items_total_payment.toLocaleString()}}</td>
          <td>{{data.emailtosend_latest_sent_via}} <br> {{data.emailtosend_latest_sent_time | date:"dd/MM/yyyy" }}</td>
          <td><button type="button"  [disabled]="data.emailtosend_type === 'no_data' || data.emailtosend_taxdata_id  === null" (click)="sendEmail(data.emailtosend_taxdata_id,index);" class="btn btn-primary">Send</button></td>
          <td style="text-align: center">
            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="selectedValues[index]"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
      </div>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip"
            (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress" height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeDownloadAll()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.html